import * as CL from '@design-system/component-library';
import { useEffect } from 'react';
import { useFormContext } from 'react-hook-form';
import {
  additionalPricingInformationMsg,
  openFormZeroPriceDetailsLabelMsg,
  openFormZeroPriceInfoPart1Msg,
  openFormZeroPriceInfoPart2Msg,
  openFormZeroPriceInfoPart3Msg,
  openFormZeroPriceInfoPart4Msg,
  openFormZeroPriceReasonLabelMsg,
  orMsg,
  requiredInformationMsg,
  t,
} from '../../../../common/i18n';
import { OpenFormGridCol, OpenFormGridRow } from '../../OpenFormComponents/OpenFormGrid.js';
import { useOpenFormAsync } from '../../OpenFormProvider.js';
import { OpenFormQuestionInput } from '../OpenFormQuestion/OpenFormQuestionInput.js';

export const zeroDetailsQuestion = { guid: 'zeroPriceDetails' };
export const zeroReasonSelect = { guid: 'zeroPriceReason' };

export const OpenFormZeroPrice = ({
  disabled,
  zeroPriceMismatch,
}: {
  disabled: boolean;
  zeroPriceMismatch: boolean;
}) => {
  const { setValue, getValues, unregister } = useFormContext();
  const { zeroReasonCodes, zeroPriceUrls } = useOpenFormAsync();

  const zeroReasonItems = Array.from(zeroReasonCodes.entries())
    .map(([code, description]) => ({
      id: code,
      value: code,
      label: description,
      html: <span>{description}</span>,
    }))
    .sort((a, b) => a.label.localeCompare(b.label));

  useEffect(() => {
    if (!zeroPriceMismatch) {
      unregister(zeroDetailsQuestion.guid);
      unregister(zeroReasonSelect.guid);
      setValue(zeroDetailsQuestion.guid, '');
      setValue(zeroReasonSelect.guid, '');
    }
  }, [unregister, setValue, zeroPriceMismatch]);

  if (!zeroPriceMismatch) {
    return null;
  }

  return (
    <OpenFormGridRow className="of-openform__view__zero-price">
      <OpenFormGridCol colWidth={9}>
        <OpenFormGridRow justifyCenter={false}>
          <OpenFormGridCol className="of-openform__view__zero-price__inner" colWidth={7}>
            <br />
            <br />
            <div>
              <h4 style={{ display: 'inline', margin: 0, padding: 0 }}>{t.OSYL(additionalPricingInformationMsg)}</h4>
              <span style={{ display: 'inline' }}> {t.LYWB(requiredInformationMsg)}</span>
            </div>
            <br />
            <div>
              <span>
                {t.E3AN(openFormZeroPriceInfoPart1Msg)}{' '}
                <CL.Link linkHref={zeroPriceUrls.elisaIntranetUrl} linkTarget="_blank">
                  {t.JPFF(openFormZeroPriceInfoPart2Msg)}
                </CL.Link>{' '}
                {t.ARFQ(orMsg)}{' '}
                <a href={zeroPriceUrls.sfKnowledgeArticleUrl} target="_blank" rel="noopener noreferrer">
                  {t.XAWP(openFormZeroPriceInfoPart3Msg)}
                </a>{' '}
                {t.Z8FX(openFormZeroPriceInfoPart4Msg)}
              </span>
            </div>
            <br />
            <CL.Combobox
              inputProps={{ autoCapitalize: 'off', autoComplete: 'off', autoCorrect: 'off' }}
              items={zeroReasonItems}
              label={t.VOMQ(openFormZeroPriceReasonLabelMsg)}
              selectedItemFormat="html"
              selectedValue={getValues(zeroReasonSelect.guid) ?? ''}
              onValueSelect={value => setValue(zeroReasonSelect.guid, value)}
            />
            <OpenFormQuestionInput
              wrapperClassName="zeroprice"
              disabled={disabled}
              name={zeroDetailsQuestion.guid}
              required={false}
              wrapGridRow={false}
              colWidth={12}
              type="textarea"
              label={t.UTNT(openFormZeroPriceDetailsLabelMsg)}
            />
          </OpenFormGridCol>
        </OpenFormGridRow>
      </OpenFormGridCol>
    </OpenFormGridRow>
  );
};
